<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <page-callout section="kiosk-team-configuration" class="mb-4" />

            <page-header>Configuration</page-header>

            <update-team-hubspot :teamId="team.id" :isEditable="team.status !== 'closed'" class="mb-4" />

            <update-team-custom-analytics v-model:team="team" :isEditable="team.status !== 'closed'" class="mb-4" />

            <update-team-default-group-status
                v-if="team.team_attributes?.group_statuses"
                :teamId="team.id"
                :isEditable="team.status !== 'closed'"
                class="mb-4"
            />

            <update-team-throughput :teamId="team.id" :isEditable="team.status !== 'closed'" class="mb-4" />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import { onMounted } from 'vue';
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import UpdateTeamHubspot from '~/components/kiosk/kiosk-teams/configuration/UpdateTeamHubspot.vue';
import UpdateTeamCustomAnalytics from '~/components/kiosk/kiosk-teams/configuration/UpdateTeamCustomAnalytics.vue';
import UpdateTeamDefaultGroupStatus from '~/components/kiosk/kiosk-teams/configuration/UpdateTeamDefaultGroupStatus.vue';
import UpdateTeamThroughput from '~/components/kiosk/kiosk-teams/configuration/UpdateTeamThroughput.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { mount, team } = useTeamDetails();

onMounted(() => {
    mount(props.teamId);
});
</script>
